import InfoModal from "@cle/components/InfoModal";

/**
 * Info dialog for the document types the AI never looks at.
 *
 * Only kursusbevis and forsikringspolice get a validation card; reduktion,
 * advokatvagt/retshjælp, dispensation, undervisning and forfatterskab are
 * assessed by the secretariat. Those pages showed an Information card and no
 * explanation at all, so the member's real question — who decides this, and how
 * many lessons do I get — went unanswered.
 */
export type ManualReviewDocumentType =
  | "reduktion"
  | "advokatvagt/retshjælp"
  | "dispensation"
  | "undervisning"
  | "forfatterskab";

type ManualReviewInfoModalProps = {
  documentType: ManualReviewDocumentType;
  /** Kommentarfeltet lukkes, når dokumentet er indberettet. */
  isReported?: boolean;
};

/** "Reduktioner bliver ikke …" — flertal, som medlemmet møder ordet i fanebladene. */
const PLURAL_SUBJECT: Record<ManualReviewDocumentType, string> = {
  reduktion: "Reduktioner",
  "advokatvagt/retshjælp": "Dokumentation for advokatvagt og retshjælp",
  dispensation: "Dispensationer",
  undervisning: "Undervisning",
  forfatterskab: "Forfatterskaber",
};

const ManualReviewInfoModal = ({
  documentType,
  isReported = false,
}: ManualReviewInfoModalProps) => {
  return (
    <InfoModal
      title={`Om ${documentType}`}
      description="Hvem vurderer dokumentationen, og hvordan lektionerne fastsættes"
      ariaLabel={`Læs mere om ${documentType}`}
    >
      <div className="d-flex flex-column gap-3">
        <p className="mb-0">
          {PLURAL_SUBJECT[documentType]} bliver ikke kontrolleret automatisk.
          Sekretariatet gennemgår dokumentationen og fastsætter antallet af
          lektioner.
          {/* TODO(sekretariatet): gælder det samme for alle fem typer, og hvornår
              kan medlemmet forvente svar? */}
        </p>
        {documentType === "undervisning" ? (
          <p className="mb-0">
            Ny undervisning står som “Afventer sekretariat”, indtil
            sekretariatet har godkendt den. Først derefter kan lektionerne
            vælges i en indberetning.
          </p>
        ) : null}
        <p className="mb-0">
          {isReported
            ? "Dokumentet er indberettet, og der kan derfor ikke længere tilføjes kommentarer."
            : "Har du spørgsmål til vurderingen, kan du skrive til sekretariatet i kortet “Besked til sekretariatet”. Når dokumentet er indberettet, kan der ikke længere tilføjes kommentarer."}
        </p>
      </div>
    </InfoModal>
  );
};

export default ManualReviewInfoModal;
